import React, { useEffect, useState, useContext, useRef } from 'react'
import classNames from 'classnames'
import { SelectInputProps } from './SelectInput.d'
import { usePageContext } from '@toasttab/shared/src/hooks/usePageContext'
import {
  FormikContext,
  FormikContextProps
} from '@toasttab/shared/src/hooks/useFormikContext'
import { getCountryNameByCountryCode } from '@toasttab/shared/src/utils/siteUtils'
import {
  generateSelectClassnames,
  generateErrorClassnames
} from './SelectInput2Classnames'

const SelectInput2 = ({
  ariaEnabled,
  classes = '',
  disabled,
  error,
  fullWidth,
  id,
  label,
  multiple,
  name,
  onBlur,
  onChange,
  options = [{ disabled: false, label: '', value: '' }],
  padding = '',
  required,
  value,
  variation = 'default',
  interaction = ''
}: SelectInputProps) => {
  const [selectedOptions, setSelectedOptions] = useState([])
  const { region } = usePageContext() || null
  const formik: FormikContextProps = useContext(FormikContext) || null
  const ref = useRef(null)

  useEffect(() => {
    const event = new Event('change', { bubbles: true })
    ref.current.dispatchEvent(event)
    if (options.length > 0) {
      options.forEach((option: any, index: number) => {
        if (
          ref.current &&
          ref.current.value === '' &&
          !multiple &&
          region &&
          getCountryNameByCountryCode(region) === option.value
        ) {
          handleChange(index)
        }
      })
    }
  }, [formik?.formik?.values])

  const handleChange = (index: number) => {
    const event = new Event('change', { bubbles: true })
    ref.current.value = ref.current.options[index].value
    ref.current.dispatchEvent(event)
  }

  const selectStyles = generateSelectClassnames({
    classes,
    value,
    multiple,
    fullWidth,
    error,
    padding
  })

  const errorClassNames = generateErrorClassnames({
    variation
  })

  return (
    <>
      <select
        className={selectStyles}
        data-interaction={interaction}
        data-testid='SelectInput2'
        disabled={disabled}
        id={id}
        multiple={multiple}
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        ref={ref}
        required={required}
        value={formik?.formik?.values[name] || value || ''}
        {...(ariaEnabled
          ? {
              'aria-controls': options.map((option) => option.value).join(', ')
            }
          : {})}
      >
        {options.map(
          ({ disabled: optionDisabled, value, label: optionLabel }) => {
            const optionStyles = classNames({
              'text-secondary': optionDisabled
            })
            return (
              <option
                className={optionStyles}
                data-testid='SelectInput2-option'
                disabled={optionDisabled}
                key={value}
                value={value}
                {...(ariaEnabled && ref.current.value === value
                  ? { 'aria-selected': true }
                  : {})}
              >
                {optionLabel}
              </option>
            )
          }
        )}
      </select>
      <label htmlFor={id} className='sr-only'>
        {label}
      </label>
      {error && (
        <div role='alert' className={errorClassNames}>
          {error}
        </div>
      )}
    </>
  )
}

export default SelectInput2
